import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import Navbar from '../components/Navbar';
import { FiPlus, FiUsers, FiArrowRight } from 'react-icons/fi';

const Teams = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    fetchTeams();
  }, []);

  const fetchTeams = async () => {
    try {
      const response = await axios.get('/teams');
      setTeams(response.data);
    } catch (error) {
      console.error('Error fetching teams:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen bg-background flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-300"></div>
        </div>
      </>
    );
  }

  return (
    <div className="min-h-screen bg-background relative">
      <Navbar />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 relative z-10">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
          <div>
            <h1 className="text-2xl font-bold text-white mb-2">Teams</h1>
            <p className="text-dark-100 text-sm">Teams & members</p>
          </div>
          {(user?.role === 'teamLead' || user?.role === 'admin') && (
            <Link
              to="/create-team"
              className="mt-4 sm:mt-0 flex items-center space-x-2 bg-gradient-to-r from-purple-200 to-purple-300 text-white px-6 py-3 rounded-lg font-semibold hover:opacity-90 transition-opacity"
            >
              <FiPlus />
              <span>New Team</span>
            </Link>
          )}
        </div>

        {teams.length === 0 ? (
          <div className="bg-stroke border border-stroke rounded-lg p-12 text-center">
            <FiUsers className="text-6xl text-dark-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-white mb-2">No teams found</h3>
            <p className="text-dark-100 mb-6">Get started by creating your first team</p>
            {(user?.role === 'teamLead' || user?.role === 'admin') && (
              <Link
                to="/create-team"
                className="inline-flex items-center space-x-2 bg-gradient-to-r from-purple-200 to-purple-300 text-white px-6 py-3 rounded-lg font-semibold hover:opacity-90 transition-opacity"
              >
                <FiPlus />
                <span>New Team</span>
              </Link>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {teams.map((team) => (
              <Link
                key={team._id}
                to={`/team/${team._id}`}
                className="bg-stroke border border-stroke rounded-lg p-6 hover:border-purple-300 transition-colors"
              >
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-xl font-semibold text-white flex-1">{team.name}</h3>
                  <FiArrowRight className="text-purple-300" />
                </div>

                {team.description && (
                  <p className="text-dark-100 text-sm mb-4 line-clamp-2">{team.description}</p>
                )}

                <div className="space-y-2">
                  <div className="flex items-center text-dark-100 text-sm">
                    <FiUsers className="mr-2" />
                    <span>Team Lead: {team.teamLead?.name}</span>
                  </div>
                  <div className="flex items-center text-dark-100 text-sm">
                    <span>{team.members?.length || 0} member{team.members?.length !== 1 ? 's' : ''}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Teams;
